import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=68d8fbaa&scoped=true&"
import script from "./menu-management.vue?vue&type=script&lang=js&"
export * from "./menu-management.vue?vue&type=script&lang=js&"
import style0 from "./menu-management.vue?vue&type=style&index=0&id=68d8fbaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8fbaa",
  null
  
)

export default component.exports